import * as t from 'io-ts';
import {map} from 'lodash';

import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

const RTimeInterval = t.readonly(
  t.type({
    startsAt: t.number,
    endsAt: t.number,
  }),
);

const RMeetingRoom = t.readonly(
  t.type({
    address: t.string,
    roomName: t.string,
    floorName: t.union([t.string, t.undefined]),
    buildingName: t.union([t.string, t.undefined]),
    capacity: t.union([t.Integer, t.undefined]),
    busyIntervals: t.union([t.readonlyArray(RTimeInterval), t.undefined]),
  }),
);

/*
 * Type.
 */

export interface TimeIntervalModel extends t.TypeOf<typeof RTimeInterval> {}
export interface MeetingRoomModel extends t.TypeOf<typeof RMeetingRoom> {}

const RMeetingRoomList = t.readonlyArray(RMeetingRoom);

/*
 * IO methods.
 */

export function parseMeetingRoom(src: any): MeetingRoomModel {
  return {
    address: src.address,
    roomName: src.room_name,
    floorName: src.floor_name || undefined,
    buildingName: src.building_name || undefined,
    capacity: src.capacity || undefined,
    busyIntervals: src.busy_intervals ? src.busy_intervals.map(parseBusyInterval) : undefined,
  };
}

function parseBusyInterval(src: any): TimeIntervalModel {
  return {
    startsAt: new Date(src.start).valueOf(),
    endsAt: new Date(src.end).valueOf(),
  };
}

export function parseMeetingRoomList(src: any): ReadonlyArray<MeetingRoomModel> {
  return map(src, parseMeetingRoom);
}

/*
 * API type.
 */

export const ApiMeetingRoomList = makeApiType('meetingRoomList', RMeetingRoomList, parseMeetingRoomList);
